import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import 'bootstrap/dist/css/bootstrap.css';
import '../home/Home.css';

class About extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="about-container">
        <MetaTags>
          <title>About</title>
          <meta
            name="description"
            content="We're changing the influencer marketing game. Gone are the days of agencies and reaching out to influencers one by one. Forget about paying a monthly subscription fee just to take a look inside. Hypepilot is an open marketplace that empowers businesses and influencers to connect and do business, so products can get promoted, and influencers can get paid."
          />
          <meta
            name="keywords"
            content="Influencer Marketing, Influencer Platform, Influencer Marketplace,YouTube Influencers, Instagram Influencers, Twitch Influencers,YouTube,Instagram,Twitch,Influencer,Influencers,Marketplace,Platform"
          />
        </MetaTags>
        <div className="nav-bar-holder">
          <nav className="navbar navbar-expand-sm navbar-light" />
        </div>
        <div className="container">
          <div className="text-header-container">
            <div className="header-holder">
              <h2 className="page-text-heading-aus">About us</h2>
            </div>
            <h2 className="our-company-header">Our Company</h2>
            <p className="padded-top-paragraph">
              We're changing the influencer marketing game. Gone are the days of
              agencies and reaching out to influencers one by one. Forget about
              paying a monthly subscription fee just to take a look inside.
              Hypepilot is an open marketplace that empowers businesses and
              influencers to connect and do business, so products can get
              promoted, and influencers can get paid.
            </p>
          </div>
        </div>

        <div className="about-us-table">
          <div className="about-us-row">
            <div className="about-us-column">
              <img className="profile-pic" src="images/armin-profile.png" />
              <p className="about-us-name">Armin Sejdic</p>
              <p className="about-us-role">(Founder & CEO)</p>
              <div className="icon-holder">
                <div className="row">
                  <div className="col-sm-4">
                    <a href="mailto:armin@hypepilot.com">
                      <div className="about-us-icon-holder">
                        <img
                          className="about-us-image"
                          src="images/email.png"
                        />
                      </div>
                    </a>
                  </div>
                  <div className="col-sm-4">
                    <a href="https://angel.co/armin-sejdic" target="_blank">
                      <div className="about-us-icon-holder">
                        <img
                          className="angellist-image"
                          src="images/angellist.svg"
                        />
                      </div>
                    </a>
                  </div>
                  <div className="col-sm-4">
                    <a
                      href="https://www.linkedin.com/in/arminsejdic/"
                      target="_blank"
                    >
                      <div className="about-us-icon-holder">
                        <img
                          className="linked-image"
                          src="images/linkedinicon.png"
                        />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="about-us-column">
              <img className="profile-pic" src="images/reid-profile.jpg" />
              <p className="about-us-name">Reid Thomas</p>
              <p className="about-us-role">(COO & Co-founder)</p>
              <div className="icon-holder">
                <div className="row">
                  <div className="col-sm-4">
                    <a href="mailto:reid@hypepilot.com">
                      <div className="about-us-icon-holder">
                        <img
                          className="about-us-image"
                          src="images/email.png"
                        />
                      </div>
                    </a>
                  </div>
                  <div className="col-sm-4">
                    <a href="https://angel.co/reversengineer" target="_blank">
                      <div className="about-us-icon-holder">
                        <img
                          className="angellist-image"
                          src="images/angellist.svg"
                        />
                      </div>
                    </a>
                  </div>
                  <div className="col-sm-4">
                    <a
                      href="https://www.linkedin.com/in/reid-thomas-5b85563a/"
                      target="_blank"
                    >
                      <div className="about-us-icon-holder">
                        <img
                          className="linked-image"
                          src="images/linkedinicon.png"
                        />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="about-us-column">
              <img className="profile-pic" src="images/adam-profile.png" />
              <p className="about-us-name">Adam Zimmer</p>
              <p className="about-us-role">(CTO & Co-founder)</p>
              <div className="icon-holder">
                <div className="row">
                  <div className="col-sm-4">
                    <a href="mailto:adam@hypepilot.com">
                      <div className="about-us-icon-holder">
                        <img
                          className="about-us-image"
                          src="images/email.png"
                        />
                      </div>
                    </a>
                  </div>
                  <div className="col-sm-4">
                    <a href="https://angel.co/adam-zimmer-1" target="_blank">
                      <div className="about-us-icon-holder">
                        <img
                          className="angellist-image"
                          src="images/angellist.svg"
                        />
                      </div>
                    </a>
                  </div>
                  <div className="col-sm-4">
                    <a
                      href="https://www.linkedin.com/in/adam-zimmer-61961151/"
                      target="_blank"
                    >
                      <div className="about-us-icon-holder">
                        <img
                          className="linked-image"
                          src="images/linkedinicon.png"
                        />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="nav-bar-holder">
          <nav className="navbar navbar-expand-sm navbar-light" />
        </div>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/home/About.js